/**
 * localStorage stats schema. Versioned for forward migrations.
 */

export interface PuzzleResult {
  puzzleId: string;
  date: string; // Melbourne YYYY-MM-DD
  seconds: number;
  firstTryCorrect: number; // 0..4
}

export interface LocalStats {
  schemaVersion: 1;
  streak: number;
  maxStreak: number;
  totalPlayed: number;
  totalWon: number;
  lastPlayedDate: string | null;
  history: PuzzleResult[];
}

export const STATS_STORAGE_KEY = 'circle-back:stats:v1';
export const STATS_HISTORY_CAP = 60;
